"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const VideoMeeting = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "25 1 17 61",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8 35.879c8.698 0 15.75-7.052 15.75-15.75 0-.438-.018-.871-.053-1.3 4.825 0 7.24.001 9.085.942a8.64 8.64 0 013.776 3.776c.942 1.848.942 4.267.942 9.106v8.352c0 4.839 0 7.258-.942 9.106a8.64 8.64 0 01-3.776 3.776c-1.848.942-4.267.942-9.106.942H19.524c-4.839 0-7.258 0-9.107-.942a8.64 8.64 0 01-3.775-3.776C5.7 48.264 5.7 45.844 5.7 41.005v-8.352-.438a15.687 15.687 0 0010.1 3.664zm33.1-6.06v13.99l13.2 7.31a.795.795 0 001.2-.708V23.215c0-.63-.64-.943-1.2-.707l-13.2 7.31z",
  fill: "#1973E8"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8 29.435a9.307 9.307 0 100-18.613 9.307 9.307 0 000 18.613zm0 3.103c6.853 0 12.408-5.556 12.408-12.41 0-6.852-5.555-12.408-12.408-12.408-6.854 0-12.41 5.556-12.41 12.409 0 6.853 5.556 12.409 12.41 12.409zm-1.518-18.58a1.551 1.551 0 113.102 0v4.653h3.102a1.551 1.551 0 110 3.102H15.833a1.551 1.551 0 01-1.551-1.55v-6.205z",
  fill: "#1973E8"
}));
var _default = exports.default = VideoMeeting;